import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import './components/index.js'
import '../static/font/font.css'
import '../static/iconfont/iconfont.css'
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VueClipboard from 'vue-clipboard2'
import { fileServer } from '@/api/api'

import App from './App'
import store from './store'
import router from './router'

import axios from 'axios'
import '@/icons' // icon
import Video from 'video.js'
import moment from 'moment'
import 'video.js/dist/video-js.css'
Vue.use(ElementUI, { locale }, VueVirtualScroller)
Vue.use(VueClipboard)
Vue.prototype.$axios = axios;
Vue.prototype.$video = Video
Vue.prototype.$moment = moment; // 日期格式化
Vue.prototype.$dimage = window.location.protocol + '//' + window.location.host;
Vue.prototype.$getUrl = (params) => {
  return new Promise((resolve) => {
    fileServer.getfile(params).then(res => {
      let { code, data } = res
      if (code === '0') {
        resolve(data)
      } else {
        resolve({})
      }
    }).catch(() => {
      resolve({})
    })
  })
}
//  设置请求拦截器和响应拦截器
axios.interceptors.request.use(
  config => {
    config.headers.common['Authorization'] = window.localStorage.getItem('token');
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js